import sk from './sk'
import en from './en'

export default {
  sk,
  en
}



// WEBPACK FOOTER //
// ./src/locales/index.js